import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IUpdateUserAuthSettingsParams {
  userIds: string[];
  authSetting: string;
}

export class UpdateUserAuthSettingsRequest extends Request<IUpdateUserAuthSettingsParams, IResult> {
  constructor(userIds: string[], authSetting: string) {
    super('updateUserAuthSettings', { userIds: userIds, authSetting: authSetting });
  }
}
